import React from "react";
import { motion } from "framer-motion";

const ToggleInput = ({
  value = true, // Default to true since left is true
  onChange,

  // Content options
  // leftText = "Required",
  // rightText = "Not Required",
  leftText,
  rightText,
  icon = "check_circle",
  leftIcon = null,
  rightIcon = null,

  size = "md",
  rounded = "md",
  disabled = false,
  className = "",

  noTitle = false, // newly added

  // Color options
  colors = {
    active: "bg-primary",
    inactive: "bg-white",
    activeText: "text-white",
    inactiveText: "text-gray-700",
    border: "border-gray-300",
  },
}) => {
  const handleToggle = () => {
    if (!disabled && onChange) {
      // Reverse the logic: if currently true, set to false; if false, set to true
      onChange(!value);
    }
  };

  const containerSizes = {
    sm: "h-8 text-xs",
    md: "h-10 text-sm",
    lg: "h-12 text-base",
    xl: "h-14 text-lg",
  };

  const radiusClasses = {
    none: "rounded-none",
    sm: "rounded-sm",
    md: "rounded-md",
    lg: "rounded-lg",
    full: "rounded-full",
  };

  const finalLeftIcon = leftIcon || icon;
  const finalRightIcon = rightIcon || icon;

  // const shouldShowLeftIcon = !!finalLeftIcon;
  // const shouldShowRightIcon = !!finalRightIcon;
  const showText = !noTitle && (leftText || rightText);

  return (
    <div
      className={`flex-1 relative flex overflow-hidden border ${
        colors.border
      } ${radiusClasses[rounded]} ${
        containerSizes[size] || containerSizes.md
      } ${
        disabled ? "opacity-60 cursor-not-allowed" : "cursor-pointer"
      } ${className}`}
      onClick={handleToggle}
    >
      {/* Sliding background */}
      <motion.div
        className={`absolute top-0 bottom-0 w-1/2 ${colors.active} z-0`}
        initial={false}
        animate={{ x: !value ? "100%" : "0%" }} // REVERSED
        transition={{ type: "spring", stiffness: 300, damping: 30 }}
      />

      {/* Left option (true) */}
      <div
        className={`flex-1 flex items-center justify-center z-10 transition-colors duration-200 ${
          value ? colors.activeText : colors.inactiveText
        }`}
      >
        <div className="flex items-center justify-center gap-1 px-4">
          {showText && leftText && <span>{leftText}</span>}
          {finalLeftIcon && (
            <span
              className={`material-symbols-outlined text-[20px] ${
                value ? "text-white" : "text-gray-500"
              }`}
            >
              {finalLeftIcon}
            </span>
          )}
        </div>
      </div>

      {/* Right option (false) */}
      <div
        className={`flex-1 flex items-center justify-center z-10 transition-colors duration-200 ${
          !value ? colors.activeText : colors.inactiveText
        }`}
      >
        <div className="flex items-center justify-center gap-1 px-4">
          {showText && rightText && <span>{rightText}</span>}
          {finalRightIcon && (
            <span
              className={`material-symbols-outlined text-[20px] ${
                !value ? "text-white" : "text-gray-500"
              }`}
            >
              {finalRightIcon}
            </span>
          )}
        </div>
      </div>
    </div>
  );
};

export default ToggleInput;

// import React from "react";
// import { motion } from "framer-motion";

// const ToggleInput = ({
//   value = true, // Default to true since left is true
//   onChange,

//   // Content options
//   leftText = "Required",
//   rightText = "Not Required",
//   icon = "check_circle",
//   leftIcon = null,
//   rightIcon = null,

//   size = "md",
//   rounded = "md",
//   disabled = false,
//   className = "",

//   // Color options
//   colors = {
//     active: "bg-primary",
//     inactive: "bg-white",
//     activeText: "text-white",
//     inactiveText: "text-gray-700",
//     border: "border-gray-300",
//   },
// }) => {
//   const handleToggle = () => {
//     if (!disabled && onChange) {
//       // Reverse the logic: if currently true, set to false; if false, set to true
//       onChange(!value);
//     }
//   };

//   const containerSizes = {
//     sm: "h-8 text-xs",
//     md: "h-10 text-sm",
//     lg: "h-12 text-base",
//     xl: "h-14 text-lg",
//   };

//   const radiusClasses = {
//     none: "rounded-none",
//     sm: "rounded-sm",
//     md: "rounded-md",
//     lg: "rounded-lg",
//     full: "rounded-full",
//   };

//   const finalLeftIcon = leftIcon || icon;
//   const finalRightIcon = rightIcon || icon;

//   const shouldShowLeftIcon = !!finalLeftIcon;
//   const shouldShowRightIcon = !!finalRightIcon;

//   return (
//     <div
//       className={`flex-1 relative flex overflow-hidden border ${
//         colors.border
//       } ${radiusClasses[rounded]} ${
//         containerSizes[size] || containerSizes.md
//       } ${
//         disabled ? "opacity-60 cursor-not-allowed" : "cursor-pointer"
//       } ${className}`}
//       onClick={handleToggle}
//     >
//       {/* Sliding background */}
//       <motion.div
//         className={`absolute top-0 bottom-0 w-1/2 ${colors.active} ${radiusClasses[rounded]} z-0`}
//         initial={false}
//         animate={{ x: !value ? "100%" : "0%" }} // REVERSED
//         transition={{ type: "spring", stiffness: 300, damping: 30 }}
//       />

//       {/* Left option (true) */}
//       <div
//         className={`flex-1 flex items-center justify-center z-10 transition-colors duration-200 ${
//           value ? colors.activeText : colors.inactiveText
//         }`}
//       >
//         {leftText}
//         {shouldShowLeftIcon && value && (
//           <span className="ml-1 material-symbols-outlined text-[20px] text-white">
//             {finalLeftIcon}
//           </span>
//         )}
//       </div>

//       {/* Right option (false) */}
//       <div
//         className={`flex-1 flex items-center justify-center z-10 transition-colors duration-200 ${
//           !value ? colors.activeText : colors.inactiveText
//         }`}
//       >
//         {rightText}
//         {shouldShowRightIcon && !value && (
//           <span className="ml-1 material-symbols-outlined text-[20px] text-white">
//             {finalRightIcon}
//           </span>
//         )}
//       </div>
//     </div>
//   );
// };

// export default ToggleInput;
